import './onlineshop.css';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { useState, useEffect} from "react";
export const OnlineShop = () => {

  return (
    <>
      <Header />
      <main>
        <div className='contents-title-box'>
          <h3>オンラインショップ</h3>
        </div>
        <div className='online-shop-info-box'>
          <div className='online-shop-info' >
            <div className='online-shop-info-title'>
              <h4><img src='img/product/nomunomono.png' /></h4>
            </div>
            <div className='online-shop-info-body' style={{ backgroundImage: `url("/img/product/daruma-opacity.png")`,  backgroundSize: 'cover' }}>
              <p>​大正１２年より、革小物を作り続けている野村製作所が運営するオンラインショップです。</p>
              <p>OEMメーカー（アパレルブランド様からデザインを頂き、代わりに製造し納品を行うメーカー）として長年の実績と経験を生かして、革の厳選から、持つ人の使い勝手を考えたお財布や、持っていて楽しくなる製品を展開しております。</p>
              <p>自社サイトやSNSを通してエンドユーザーからの生の声を収集し、商品開発に活かすことで、お客様に寄り添ったものづくりを心掛けています。</p>
              <p>また、近年は革の端切れを使用した小物を企画・製作し、材料を余すことなく使用したり、芯材や緩衝材を環境負荷の低いものにしたりすることで、サステナブルな取り組みにも力を入れています。</p>
            </div>
            <a href="https://nomura.handcrafted.jp/" target="_blank" rel="noopener">
              <div className='btn-box' >
                <p>購入サイトに移動</p>
              </div>
            </a>
          </div>
        <div className='online-shop-info' >
            <div className='online-shop-info-title'>
              <h4><img src='img/product/crocco-shop-logo.png' /></h4>
            </div>
            <div className='online-shop-info-body' style={{ backgroundImage: `url("/img/product/mobilepost-opacity.png")`, backgroundSize: 'cover' }}>
              <p>「CROCCO（黒子）」は野村製作所が2022年に新たに立ち上げたブランドです。</p>
              <p>OEM生産（アパレルブランド様からデザインを頂き、代わりに製造し納品を行うメーカー）のプロフェッショナルとして培った企画力と技術力を活かし「日本の品格」を感じさせるものづくりを目指しています。</p>
              <p>「CROCCO」で採用しているシュランケンカーフレザーは革とは思えない軽さが魅力で、お手入れもほとんど必要ありません。</p>
              <p>マットな質感と独特なドライタッチが特徴で、粒がそろったシボを出すため、伝統的なレシピによる薬品の調合や、ドラムで革を空打ちするなど、圧倒的な時間がかけられており、ヨーロッパのタンナーの知恵と技術が結集した素材です。​</p>
              <p>そんな上質な革の魅力を最大限活かすとともに、お客様の日常に溶け込み、様々な場面に彩りを与える「黒子」となれるような製品を目指し、シンプルだからこそ少しのミスも許されない、職人の技が光るデザインを取り入れました。​</p>
            </div>
            <a href="https://crocco.nomura-leathercraft.com/" target="_blank" rel="noopener">
              <div className='btn-box' >
                <p>購入サイトに移動</p>
              </div>
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
